import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IDeleteServerUsersParams {
  ids: string[];
}

export interface IDeleteServerUsersResult extends IResult {
}

export class DeleteServerUsersRequest extends Request<IDeleteServerUsersParams, IDeleteServerUsersResult> {
  constructor(params: IDeleteServerUsersParams) {
    super('deleteServerUsers', params);
  }
}
